<script lang="ts" setup>
    import { computed, onMounted, ref } from 'vue'
    import { useCloudflareStore } from '~~/stores/cloudflare'
    import type { PickerContext } from '../../composables/usePickerRegistry'

    const props = defineProps<{
        modelValue: string | null
        context?: PickerContext
        readonly?: boolean
        dense?: boolean
        outlined?: boolean
        borderless?: boolean
        label?: string
    }>()

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void
    }>()

    const cloudflareStore = useCloudflareStore()
    const loading = ref(false)

    const zones = computed(() =>
        cloudflareStore.zones.map((z: any) => ({ value: z.id, label: z.name })),
    )

    onMounted(async () => {
        loading.value = true
        try {
            await cloudflareStore.fetchZones()
        }
        finally {
            loading.value = false
        }
    })
</script>

<template>
    <q-select
        :model-value="modelValue"
        :options="zones"
        :label="label ?? 'Cloudflare Zone'"
        :readonly="readonly"
        :dense="dense"
        :outlined="outlined"
        :borderless="borderless"
        :loading="loading"
        emit-value
        map-options
        clearable
        use-input
        input-debounce="0"
        @update:model-value="(v) => emit('update:modelValue', v)"
    />
</template>
